import firebase from "firebase";

export var firebaseConfig = {
  apiKey: "AIzaSyB4bf9E9fr0UgeCSx7hTfW4dcg9kmLq6to",
  authDomain: "memora-admin-platform.firebaseapp.com",
  projectId: "memora-admin-platform",
  storageBucket: "memora-admin-platform.appspot.com",
  messagingSenderId: "991317551432",
  appId: "1:991317551432:web:9874a36fe61953f8b76b7d",
  measurementId: "G-GV30ENHER6",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
export default firebase;
